<template>
    <div class="inquiries" v-if="showInquiries || building || showAsPage">
      <div class="register__form">
        <form class="form-contact" autocomplete="off">
          <div class="contact-form__wrapper">
            <div class="contact-form__wrapper__field" :class="{'input--filled': userData.first_name.length > 0, invalid: invalidName}">
              <input type="text" name="first_name" v-model="userData.first_name">
              <label for="first_name"><span>First Name*</span></label>
            </div>
            <div class="contact-form__wrapper__field" :class="{'input--filled': userData.last_name.length > 0, invalid: invalidLastName}">
              <input type="text" name="last_name" v-model="userData.last_name">
              <label for="last_name"><span>Last Name*</span></label>
            </div>
          </div>
          <div class="contact-form__wrapper">
            <div class="contact-form__wrapper__field" :class="{'input--filled': userData.email.length > 0, invalid: invalidEmail}">
              <input type="email" name="email_name" v-model="userData.email">
              <label for="email_name"><span>Email*</span></label>
            </div>
            <div class="contact-form__wrapper__field" :class="{'input--filled': userData.phone.length > 0}">
              <input type="text" name="phone_name" v-model="userData.phone">
              <label for="phone_name"><span>Phone</span></label>
            </div>
          </div>
          <div class="contact-form__wrapper">
            <div class="contact-form__wrapper__select" :class="{'input--filled': userData.price_range.length > 0}">
              <select class="select-options" name="price-range" v-model="userData.price_range">
                <option value="Up to $1M">Up to $1M</option>
                <option value="$1M - $2M">$1M - $2M</option>
                <option value="$2M - $3M">$2M - $3M</option>
                <option value="$3M - $5M">$3M - $5M</option>
                <option value="$5M+">$5M+</option>
              </select>
              <label for="price-range"><span>Price range</span></label>
            </div>
            <div class="contact-form__wrapper__select" :class="{'input--filled': userData.bedroom_type.length > 0}">
              <select class="select-options" name="residence" v-model="userData.bedroom_type">
                <option value="Studio">Studio</option>
                <option value="1 Bedroom">1 Bedroom</option>
                <option value="2 Bedroom">2 Bedroom</option>
                <option value="3 Bedroom">3 Bedroom</option>
              </select>
              <label><span>Desired residence type</span></label>
            </div>
          </div>
          <div class="contact-form__wrapper">
            <div class="contact-form__wrapper__select" :class="{'input--filled': userData.hear_from.length > 0}">
              <select class="select-options" name="aboutUs" v-model="userData.hear_from">
                <option value="Advertisement">Advertisement</option>
                <option value="Building sign">Building sign</option>
                <option value="Broker">Broker</option>
                <option value="Live/work in the neighborhood">Live/work in the neighborhood</option>
                <option value="Online search">Online search</option>
                <option value="Other">Other</option>
                <option value="Press article">Press article</option>
                <option value="Referral">Referral</option>
                <option value="StreetEasy">StreetEasy</option>
              </select>
              <label><span>How did you hear about us?</span></label>
            </div>
            <div class="contact-form__wrapper__select" :class="{'input--filled': userData.prefer_contact.length > 0}">
              <select class="select-options" name="prefer" v-model="userData.prefer_contact">
                <option value="Email">Email</option>
                <option value="Phone">Phone call</option>
                <option value="Text">Text</option>
              </select>
              <label><span>How you prefer to be contacted?</span></label>
            </div>
          </div>
          <div class="contact-form__wrapper question">
            <div class="contact-form__wrapper__question">
              <span>Are you a broker?</span>
              <div class="broker broker-first">
                <input type="radio" name="broker_yes" :checked="firstInputChecked">
                <label for="broker_yes" @click="checkInput('first')">Yes</label>
              </div>
              <div class="broker">
                <input type="radio" name="broker" :checked="lastInputChecked">
                <label for="broker_no" @click="checkInput('last')">No</label>
              </div>
            </div>
            <transition name="fade">
              <div class="contact-form__wrapper__field" :class="{'input--filled': userData.brokerage_company.length > 0,  invalid: invalidBrokerCompany}" :style= "[showBroker ? {'visibility': 'visible'} : {'visibility': 'hidden'}]">
                <input type="text" name="broker" v-model="userData.brokerage_company">
                <label for="broker_name"><span>Brokerage company*</span></label>
              </div>
            </transition>

          </div>
          <button class="btn-submit" @click.prevent="submitForm" :disabled="loading">
            Send
          </button>
        </form>
        <div class="form-footer">
          <img src="../assets/corcoran-logo.png" alt="form logo" class="form-footer--image">
          <div class="form-footer-block">
              <span class="form-footer-block-address">
              <a class="form-footer-block-link" href="https://www.google.com/maps/place/214+W+72nd+St,+New+York,+NY+10023/@40.778766,-73.9848932,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2588a0bebb1f9:0x882ec6eb3c9e86f8!8m2!3d40.778766!4d-73.9827045" target="_blank">214 W 72nd Street, New York, NY 10023</a>
              <br>
              <a class="form-footer-block-link" href="tel:631-834-8523"> 631-834-8523</a>
              <a class="form-footer-block-link" href="mailto:info@parkerwest.com"> info@parkerwest.com</a>
              </span>
          </div>
            <span class="form-footer--description"> {{ formFooter}}</span>
        </div>
      </div>
    </div>
</template>

<script>
    const dataLayer = window.dataLayer || [];
    export default {
      name: "Inquiries",
      data: () => ({
        showInquiries: false,
        formInfo: 'An entirely new vision of home in the heart of the Upper West Side. ' +
          'ParkerWest reimagines well-designed living conceived from the ground up by award-winning design firm GRADE New York. ' +
          'The 22-story new construction building offers warm, sophisticated floor-through three-bedroom sanctuaries where ' +
          'residents step directly off the elevator into the brightness of their homes. With onsite amenities, including a gym ' +
          'and 24-hour doorman, and access to New York\'s premier cultural landmarks nearby, ParkerWest embraces the comforts ' +
          'of home amidst the greatness of the city.',
        formFooter: 'Equal Housing Opportunity. Sponsor reserves the right to make changes in accordance with the terms of the Offering Plan.  All renderings reflect the planned scale and spirit of the Building. Sponsor makes no representation that any future construction in the neighborhood surrounding the condominium will not result in the obstruction of the views from any windows, and/or terraces. Sponsor reserves the right to make changes and makes no representations or warranties except as may be set forth in the Offering Plan. The complete offering terms are in the Offering Plan, ' +
          'File No. CD19-0084. Sponsor: Aventis-72nd LLC, 161 Chrystie Street, New York, NY 10002.',
        userData: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          price_range: '',
          bedroom_type: '',
          hear_from: '',
          prefer_contact: '',
          brokerage_company: ''
        },
        showBroker: false,
        firstInputChecked: false,
        lastInputChecked: false,
        loading: false,
          invalidEmail: false,
          invalidName: false,
          invalidLastName: false,
          invalidBrokerCompany: false,
          submitMessage: false
      }),
      props: {
        building: {
          type: Boolean,
          default: false,
          required: false
        },
        showAsPage: {
          type: Boolean,
          default: false,
          required: false
        }
      },
      created() {
        this.$bus.on('showInquiries', this.toggleInquiries);
      },
        watch: {
            userData: {
                handler: 'checkValue',
                immediate: false,
                deep: true
            }
        },
      methods: {
          checkValue () {
              if (this.userData.first_name.length) {
                  this.invalidName = false
              }
              if (this.userData.last_name.length) {
                  this.invalidLastName = false
              }
              if (this.userData.email.length) {
                  this.invalidEmail = false
              }
              if (this.showBroker && this.userData.brokerage_company) {
                  this.invalidBrokerCompany = false
              }
          },
        toggleInquiries(value) {
          this.showInquiries = value;
        },
        submitForm() {
            this.invalidName = false
            this.invalidLastName = false
            this.invalidEmail = false
            this.invalidBrokerCompany = false
          if (this.loading) return;
            if (!this.userData.first_name.length) {
                this.invalidName = true
            }
            if (!this.userData.last_name.length) {
                this.invalidLastName = true
            }
            if (!this.userData.email) {
                this.invalidEmail = true
            }
            if (this.showBroker && !this.userData.brokerage_company.length) {
                this.invalidBrokerCompany = true
            }
            if (this.invalidEmail || this.invalidLastName || this.invalidName || this.invalidBrokerCompany) {
                return
            }

          this.loading = true;

          fetch('/registrations-28sj2yskwi', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(this.userData)
          })
          .then((response) => {
                  response.json()
                  this.loading = false;
                  this.userData.first_name = ''
                  this.userData.last_name = ''
                  this.userData.email = ''
                  this.userData.phone = ''
                  this.userData.hear_from = ''
                  this.userData.price_range = ''
                  this.userData.brokerage_company = ''
                  this.userData.bedroom_type = ''
                  this.userData.prefer_contact = ''
                  this.showBroker = false
                  this.firstInputChecked = false
                  this.lastInputChecked = false
                  this.submitMessage = true
                  if (window.innerWidth > 1200) {
                      this.building = false
                      this.showAsPage = false
                      this.$bus.emit('showInquiries', false);
                  }
                  dataLayer.push({
                      'event': 'Inquiry Form Submit'
                  })
                  // this.$bus.emit('clickOnSend', true)
              })
          .finally(() => {
              this.loading = false;
          });
        },
        checkInput(value) {
          if(value === 'first') {
            this.firstInputChecked = true
            this.lastInputChecked = false
            this.showBroker = true
          } else {
            this.firstInputChecked = false
            this.lastInputChecked = true
            this.showBroker = false
          }
        }
      }
    }
</script>

<style scoped lang="scss">
.invalid {
    border-bottom-color: red !important;


    label, input {
        color: red !important;
    }
}
</style>
